var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.6,30H5.4V0h19.3V30z M6.3,29h17.3V1H6.3V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6,25.3H9.4V4.7h11.2V25.3z M10.3,24.4h9.3V5.6h-9.3V24.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 11.7,
    transform: "matrix(0.7235 -0.6903 0.6903 0.7235 -10.6248 17.5226)",
    width: 1,
    height: 20.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 7,
    transform: "matrix(0.7129 -0.7012 0.7012 0.7129 -0.5112 13.7701)",
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.6,
    cy: 14.5,
    rx: 2.2,
    ry: 2.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorRight);
export default __webpack_public_path__ + "static/media/door_right.62c88edf311b6c5e4889089df3e33854.svg";
export { ForwardRef as ReactComponent };